// @flow
import {useContext, useEffect, useState} from "react";
import {gotNumNotifications} from "../ACTIONS/clientActions";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {useCookies} from "react-cookie";
import commonClientApi from "../GUI_COMMON/API/commonClientApi";
import ArchiverClientApi from "../API/archiverClientApi";

const NotifyAndUpdateTimer = () => {

    const REFRESH_TIMEOUT_MSECS = 60000;        // get new notification numbers this often

    const [globalState, dispatch] = useContext(StoreContext);
    const [refreshTimer, setRefreshTimer] = useState();
    
    const [cookies,] = useCookies();
    
    useEffect(() => {
        console.debug("NotifyAndUpdateTimer starting up...");
        if (globalState.clientInfo.userId!==-1) {
            if (!refreshTimer && LIUtils.isAuthenticatedHook(cookies) && globalState.notifications.initialized !== true) {
                getNumNotifications();
                startNotifRefreshTimer();
            }
        }
        else { // user logged out
            stopNotifRefreshTimer();
        }
    }, [globalState.clientInfo.userId,globalState.notifications.initialized]);  // eslint-disable-line react-hooks/exhaustive-deps
    
    function getNumNotifications() {
        ArchiverClientApi.getNumNotifications().then(({numNotifs,numUnread}) => {
            
            dispatch(gotNumNotifications(numNotifs??0,numUnread??0)); // <#>
        })
        .catch(responseError => commonClientApi.ShowErrorIfNotUnauthourized(responseError));
    }
    
    function startNotifRefreshTimer() {
        console.debug("startNotifRefreshTimer() - new timer starting");
        if(!refreshTimer) {
            setRefreshTimer(setInterval(getNumNotifications, REFRESH_TIMEOUT_MSECS));
        }
    }
    
    function stopNotifRefreshTimer() {
        console.debug("stopNotifRefreshTimer() - stopping timer");
        if(refreshTimer) {
            clearInterval(refreshTimer);
            setRefreshTimer(null);
        }
    }
    
    return null;
}

NotifyAndUpdateTimer.propTypes = {
    
}

export default NotifyAndUpdateTimer;